import { render } from "./infoCarCad.vue?vue&type=template&id=2ce17544&scoped=true"
import script from "./infoCarCad.vue?vue&type=script&lang=js"
export * from "./infoCarCad.vue?vue&type=script&lang=js"

import "./infoCarCad.vue?vue&type=style&index=0&id=2ce17544&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce17544"]])

export default __exports__